
// services/EmployeeService.js
import axiosInstance from '../utils/axiosInstance.js';
import API_BASE_URL from './common/common.js';

class EmployeeService {
  /**
   * Ensure token is valid before making API calls
   * @private
   */
  static async ensureValidToken() {
    // Token validation is now handled automatically by axiosInstance interceptor
    // This method is kept for backward compatibility but no longer needed
    // The interceptor will validate and refresh tokens before every request
    return Promise.resolve();
  }

  /**
   * Fetch all employee details from the API
   * @returns {Promise} Promise that resolves to an array of employee objects
   */
  static async fetchAllEmployeeDetails() {
    try {
      await this.ensureValidToken();
      const response = await axiosInstance.get(`${API_BASE_URL}/fetchAllEmployeeDetails`);
      return response.data;
    } catch (error) {
      console.error('Error fetching employee details:', error);
      throw error;
    }
  }
  
  /**
   * Fetch a specific employee's details by ID
   * @param {string} employeeId - The ID of the employee to fetch
   * @returns {Promise} Promise that resolves to the employee object
   */
  static async fetchEmployeeById(employeeId) {
    try {
      await this.ensureValidToken();
      // Since there's no specific endpoint for fetching a single employee,
      // we'll fetch all employees and filter for the one we want
      const allEmployees = await this.fetchAllEmployeeDetails();
      return allEmployees.find(emp => emp.aa_app_employee_id === employeeId) || null;
    } catch (error) {
      console.error('Error fetching employee details:', error);
      throw error;
    }
  }
  
  /**
   * Fetch all application details from the API
   * @returns {Promise} Promise that resolves to an array of application objects
   */
  static async fetchAllApplicationDetails() {
    try {
      await this.ensureValidToken();
      const response = await axiosInstance.get(`${API_BASE_URL}/fetchAllApplicationDetails`);
      return response.data;
    } catch (error) {
      console.error('Error fetching application details:', error);
      throw error;
    }
  }
}

export default EmployeeService;